import React, { useState } from "react";
import "./SupportAndConsultingPage.css";
import SupportAndConsultingOverview from "./SupportAndConsultingOverview";
import BannerImage from "../../../assets/other_image/supportNEw.jpg";
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";

import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/* FAQ Data */
const faqData = [
  { question: "What does Nextech’s PLM Support cover?", answer: "Our support covers day-to-day issue resolution, troubleshooting, system monitoring, integrations, and performance optimization for Teamcenter PLM." },
  { question: "Do you provide 24×7 support?", answer: "Yes. We offer 24×7 support services with proactive monitoring and rapid resolution." },
  { question: "Can you support interface applications linked to Teamcenter?", answer: "Absolutely. We provide expert support for S, E, MSO, and other integrated enterprise applications." },
  { question: "What engagement models are available?", answer: "We offer onsite, offshore, on-call, and hybrid models to meet diverse business requirements." },
  { question: "How do you ensure system reliability?", answer: "Through proactive monitoring, tuning, and best practice implementation, we keep your PLM system stable and secure." },
  { question: "Does Nextech take full ownership of PLM systems?", answer: "Yes. We provide support services with full ownership, ensuring end-to-end accountability and continuous system improvements." }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-question" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, index) => (
      <article className="feature-tile" key={index}>
        {item.icon && (
          <div className="tile-icon">
            {typeof item.icon === "string" && item.icon.startsWith("http") ? (
              <img src={item.icon} alt={item.title} />
            ) : (
              item.icon
            )}
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const SupportAndConsulting = () => {
  const benefitsItems = [
    "Resolve Day-to-Day Issues – Ensure uninterrupted PLM operations by addressing usage-related challenges quickly and effectively.",
    "Expert Troubleshooting – Gain guidance from PLM experts for user activities, workflows, and configurations.",
    "Support for Interface Applications – Get seamless support for integrations with applications like S, E, and MSO.",
    "Enable Best Practices – Standardize usage of Teamcenter with proven methods that optimize performance.",
    "Enhance Reliability & Performance – Proactively improve availability, uptime, and responsiveness across systems.",
    "Maximize ROI – Leverage cost-effective consulting to fully realize the value of your PLM investments."
  ];

  const ourSolutionsItems = [
    { icon: "👨‍💻", title: "Onsite Support", content: "Dedicated professionals available at your location for direct issue resolution." },
    { icon: "🌍", title: "Offshore Support", content: "Remote experts offering round-the-clock system administration and consulting." },
    { icon: "⏰", title: "24×7 Support System", content: "Continuous monitoring and assistance to keep Teamcenter running at all times." },
    { icon: "📞", title: "On-Call Support", content: "Instant access to Teamcenter experts when unexpected issues arise." },
    { icon: "🔒", title: "Full Ownership Support", content: "Dedicated responsibility for your PLM system with proactive management." },
    { icon: "⚙️", title: "Custom Engagement Models", content: "Tailored support plans to align with business priorities and budgets." }
  ];

  const whyNextechItems = [
    { icon: "✅", title: "Comprehensive Troubleshooting", content: "Fast resolution of Teamcenter issues, ensuring smooth day-to-day operations." },
    { icon: "🔗", title: "Integration Expertise", content: "Reliable support for connected applications like S, E, MSO, and other enterprise systems." },
    { icon: "📘", title: "Best Practice Enablement", content: "Implementation of proven methodologies to optimize PLM usage and performance." },
    { icon: "⚡", title: "Flexible Support Options", content: "Onsite, offshore, 24×7, and on-call models to fit your business needs." },
    { icon: "🛡️", title: "Proactive Ownership", content: "Support services with complete accountability for system reliability and performance." },
    { icon: "💡", title: "Business Value Delivery", content: "Focus on maximizing ROI, reducing downtime, and enhancing user productivity." }
  ];

  return (
    <>
      {/* ✅ Meta Tags for SEO */}
     <Helmet>
      <title>Teamcenter Support &amp; Consulting Services in Pune | NexTech PLM</title>
      <meta name="description" content="Get expert Teamcenter support and consulting in Pune, India. Nextech PLM ensures smooth PLM operations, enhanced system performance, and dedicated post-implementation assistance." />
      <meta name="keywords" content="Teamcenter consulting Pune, PLM support services India, Teamcenter troubleshooting, PLM consulting experts, Teamcenter technical support" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/teamcenter-support-consulting-services" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Teamcenter Support & Consulting Services in Pune | NexTech PLM" />
      <meta property="og:description" content="Get expert Teamcenter support and consulting in Pune, India. Nextech PLM ensures smooth PLM operations and enhanced system performance." />
      <meta property="og:url" content="https://nextechplm.com/teamcenter-support-consulting-services" />
      <meta property="og:image" content="https://nextechplm.com/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Teamcenter Support & Consulting Services in Pune | NexTech PLM" />
      <meta name="twitter:description" content="Get expert Teamcenter support and consulting in Pune, India. Nextech PLM ensures smooth PLM operations and enhanced system performance." />
      <meta name="twitter:image" content="https://nextechplm.com/logo192.png" />
</Helmet>

    <main className="support-consulting-page">
      <Banner image={BannerImage} heading="Support & Consulting Solutions" />
      <FloatingContactUs />
      <SupportAndConsultingOverview />

      {/* Benefits + Quick Links Section */}
      <section className="section benefits-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 col-12">
              <div className="benefits-card">
                <h3 className="benefits-heading">Business Benefits of NexTech Support & Consulting</h3>
                <ul className="benefits-list">
                  {benefitsItems.map((item, i) => (
                    <li key={i}>
                      <span className="benefit-icon">✔</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="quick-links">
                <h4>Quick Links</h4>
                <ul>
                  <li><NavLink to={"/teamcenter/plm-document-management"}>Document Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/manufacturing-data-process-management"}>Manufacturing Data and Process Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/product-bom-variability-management"}>Product BOM and Variability Management</NavLink></li>
                  <li><NavLink to={"/teamcenter/community-collaboration"}>Teamcenter Community Collaboration</NavLink></li>
                  <li><NavLink to={"/teamcenter/cloud-implementation"}>Teamcenter Implementation on Cloud</NavLink></li>
                  <li><NavLink to={"/teamcenter/ecad-integration"}>ECAD Integration</NavLink></li>
                  <li><NavLink to={"/teamcenter/mcad-integration"}>MCAD Integration</NavLink></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookDemoSection />

      {/* Our Solutions */}
      <section className="section featured-solutions-section">
        <div className="container">
          <SectionHeader title="Our Support & Consulting Solutions" subtitle="Comprehensive PLM support to keep your Teamcenter ecosystem running optimally." />
          <TileGrid items={ourSolutionsItems} />
        </div>
      </section>

      {/* Why NexTech */}
      <section className="section our-solutions-section">
        <div className="container">
          <SectionHeader title="Why Choose NexTech for Support & Consulting?" />
          <TileGrid items={whyNextechItems} />
        </div>
      </section>

      {/* Support Process */}
      <section className="section nextech-amc-section">
        <div className="container">
          <SectionHeader title="NexTech’s Support & Consulting Process" />
          <p className="section-intro">
            Our process ensures consistent, reliable, and measurable support outcomes for your PLM environment.
          </p>

          <div className="amc-process-card">
            <ul className="amc-process-list">
              <li>
                <h4>Initial Assessment</h4>
                <p>Review of your existing PLM setup, configurations, and usage challenges.</p>
              </li>
              <li>
                <h4>Issue Diagnosis</h4>
                <p>Identifying root causes and providing quick, actionable resolutions.</p>
              </li>
              <li>
                <h4>Best Practice Implementation</h4>
                <p>Standardizing Teamcenter operations for long-term stability and security.</p>
              </li>
              <li>
                <h4>Integration & Monitoring</h4>
                <p>Ensuring connected applications run seamlessly with proactive system checks.</p>
              </li>
              <li>
                <h4>Continuous Optimization</h4>
                <p>Delivering improvements that enhance scalability, uptime, and ROI.</p>
              </li>
            </ul>
          </div>

          <p className="section-outro">
            With NexTech’s Support & Consulting Services, your Teamcenter system achieves peak reliability, security, and performance.
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section className="section faq-section">
        <div className="container">
          <SectionHeader title="Support & Consulting FAQs" />
          <div className="faq-container">
            {faqData.map((item, i) => (
              <FAQItem key={i} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>

      <Letsgetintouch />
    </main>
</>
  );
};

export default SupportAndConsulting;
